import _ from "lodash";

export const Mutations = {
    loadInBoard(state, ui) {
        let data = _.union(ui, state.itemsIn);
        let res = _.uniqWith(data, function (first, second) {
            return (first.id != second.id) ? false : true;
        });
        res = _.map(res, (i) => {
            i.id = Number(i.id);
            return i;
        });
        state.itemsIn = res;
    },
    loadDepartureBoard(state, ui) {
        let data = _.union(ui, state.itemsDeparture);
        let res = _.uniqWith(data, function (first, second) {
            return (first.id != second.id) ? false : true;
        });
        res = _.map(res, (i) => {
            i.id = Number(i.id);
            return i;
        });
        state.itemsDeparture = res;
    },
    setZoomScaleIn(state, zoomScale) {
        state.zoomScaleIn = zoomScale;
    },
    setZoomScaleDeparture(state, zoomScale) {
        state.zoomScaleDeparture = zoomScale;
    },
    removeFromDepartureBoard(state, removedBoardIds) {
        _.forEach(removedBoardIds, function (boardId) {
            state.itemsDeparture = _.filter(state.itemsDeparture, function (item) {
                return item.id != boardId;
            });
        });
    },
    removeFromInBoard(state, removedBoardIds) {
        _.forEach(removedBoardIds, function (boardId) {
            state.itemsIn = _.filter(state.itemsIn, function (item) {
                return item.id != boardId;
            });
        });
    },
};
